import * as React from 'react';

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <mask
      id="a"
      width="16"
      height="16"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
    >
      <path fill="#D9D9D9" d="M0 0h16v16H0z"></path>
    </mask>
    <g mask="url(#a)">
      <path
        fill="#4024D3"
        d="m7.1 10.5 3.25-2.083a.47.47 0 0 0 .233-.416.47.47 0 0 0-.233-.417L7.1 5.501a.46.46 0 0 0-.508-.025.47.47 0 0 0-.259.441v4.167q0 .3.259.442A.46.46 0 0 0 7.1 10.5m.9 4.167a6.5 6.5 0 0 1-2.6-.525 6.7 6.7 0 0 1-2.117-1.425 6.7 6.7 0 0 1-1.425-2.116A6.5 6.5 0 0 1 1.333 8q0-1.385.525-2.6a6.7 6.7 0 0 1 1.425-2.117q.9-.9 2.117-1.425A6.5 6.5 0 0 1 8 1.334q1.383 0 2.6.525t2.117 1.425 1.425 2.117q.525 1.215.525 2.6 0 1.383-.525 2.6a6.7 6.7 0 0 1-1.425 2.116q-.9.9-2.117 1.425a6.5 6.5 0 0 1-2.6.525m0-1.333q2.234 0 3.783-1.55 1.55-1.55 1.55-3.783 0-2.234-1.55-3.784T8 2.667t-3.783 1.55-1.55 3.784 1.55 3.783T8 13.334"
      ></path>
    </g>
  </svg>
);
